export default "__VITE_ASSET__BtjyCkgo__"